var map = {
	"./burnout.json": 72874,
	"./depression.json": 83536,
	"./likelihood_of_turnover.json": 78124,
	"./overall_wellbeing.json": 85067,
	"./professional_satisfaction.json": 40890,
	"./sleep.json": 29544,
	"./stress_and_anxiety.json": 40431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10495;